import { useMutation } from '@tanstack/react-query';
import BillingService from '../services/BillingService';
import Notification from '../../App/components/Notification';
import { downloadBlob, parseArrayBufferError } from '../utils/downloadBlob';
export function useDownloadBankSlip() {
    return useMutation({
        mutationFn: function (id) { return BillingService.getBankSlip(id); },
        onSuccess: function (res) {
            downloadBlob(res.data, 'boleto.pdf');
        },
        onError: function (err) {
            var _a, _b;
            var status = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status;
            if (status === 422 || status === 500) {
                var data = parseArrayBufferError((_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data);
                Notification().Notify.failure(data.error || 'Erro ao gerar boleto');
            }
            else {
                Notification().Notify.failure('Erro ao baixar boleto');
            }
        },
    });
}
